module.exports = __webpack_public_path__ + "static/assets/efbc0140c559e0b7d575e9700adb3734.gif";